import type { Entity } from '@backstage/catalog-model';

export const filterDemoEntities = <E extends Entity>(entities: E[]): E[] =>
  entities.filter(entity => !entity.metadata.tags?.includes('demo'));
